import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import useTokenNavigation from '../hook/token-navigation';
import useDomainParam from '../hook/domain-param';
/*
 Ned to wrap Outlet in <KeepAliveOutlet> </KeepAliveOutlet>
 not doing this since there needs to be some changes in the
 components to make it work
 */
function KeepAliveOutlet({ children }) {
    const location = useLocation();
    const [cache, setCache] = React.useState({});
    React.useEffect(() => {
        setCache((prev) => (Object.assign(Object.assign({}, prev), { [location.pathname]: children })));
    }, [location.pathname, children]);
    return (_jsx(_Fragment, { children: Object.entries(cache).map(([path, element]) => path === location.pathname ? element : null) }));
}
function WelcomeLayout() {
    console.log('WelcomeLayout::');
    const isDomainAvailable = useDomainParam();
    useTokenNavigation(isDomainAvailable);
    useEffect(() => {
        console.log('WelcomeLayout::isDomainAvailable:', isDomainAvailable);
    }, [isDomainAvailable]);
    return (_jsx("main", { children: _jsx(Suspense, Object.assign({ fallback: _jsx("div", { children: "Loading..." }) }, { children: _jsx(Outlet, {}) })) }));
}
export default WelcomeLayout;
